import React from "react";

import isIntuit from "Intuit/isIntuit";

import CobaltHeader from "Cobalt/Header";
import ClassicHeader from "Common/Header";

import { useThemeContext } from "./Context";

const Header = ({ children, cobaltProps = {}, classicProps = {}, intuitProps = {}, ...rest }) => {
  const { intuit, cobalt } = useThemeContext();
  return isIntuit() && intuit ? (
    <ClassicHeader {...rest} {...intuitProps}>
      {children}
    </ClassicHeader>
  ) : cobalt ? (
    <CobaltHeader {...rest} {...cobaltProps}>
      {children}
    </CobaltHeader>
  ) : (
    <ClassicHeader {...rest} {...classicProps}>
      {children}
    </ClassicHeader>
  );
};

export default Header;
